// extracted by mini-css-extract-plugin
module.exports = {"root":"mIndex_root__QzLWy","tips":"mIndex_tips__uCGRc","arrow":"mIndex_arrow__IRYlv","top":"mIndex_top__bds3z"};